var _rect, _rect2, _path, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCmndFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 82,
    viewBox: "0 0 143 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 81.2734,
    rx: 6.85851,
    fill: "#ECECF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0312,
    y: 8.5726,
    width: 60.6978,
    height: 61.0408,
    rx: 6.85851,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3803 39.0928C48.9004 39.0928 53.3742 34.619 53.3742 29.099C53.3742 23.5789 48.9004 19.1051 43.3803 19.1051C37.8603 19.1051 33.3865 23.5789 33.3865 29.099C33.3865 34.619 37.8603 39.0928 43.3803 39.0928ZM50.376 41.5913H49.0721C47.3388 42.3876 45.4103 42.8405 43.3803 42.8405C41.3503 42.8405 39.4296 42.3876 37.6885 41.5913H36.3846C30.5913 41.5913 25.8911 46.2915 25.8911 52.0848V55.3328C25.8911 57.4018 27.5698 59.0805 29.6388 59.0805H57.1218C59.1909 59.0805 60.8695 57.4018 60.8695 55.3328V52.0848C60.8695 46.2915 56.1693 41.5913 50.376 41.5913Z",
    fill: "#C4CFE5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81.959,
    y: 10.6305,
    width: 53.4964,
    height: 17.4892,
    rx: 3.42926,
    fill: "#C4CFE5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81.959,
    y: 36.6933,
    width: 35.3213,
    height: 10.9736,
    rx: 3.42926,
    fill: "#C4CFE5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81.959,
    y: 56.2393,
    width: 53.4964,
    height: 10.9736,
    rx: 3.42926,
    fill: "#C4CFE5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmndFront);
export default __webpack_public_path__ + "static/media/cmnd-front.982b1aa6040f5417cd390dda2bdd2655.svg";
export { ForwardRef as ReactComponent };